/**
 * @generated SignedSource<<832aa01ff03c6a00f6697d7b973e219b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StartContentNodeInput = {
  clientMutationId?: string | null;
  contentNodeId: string;
};
export type useCardAdvanceContentNavigation_StartContentNodeMutation$variables = {
  input: StartContentNodeInput;
};
export type useCardAdvanceContentNavigation_StartContentNodeMutation$data = {
  readonly LearnV2: {
    readonly startContentNode: {
      readonly contentSubmission: {
        readonly id: string;
      };
    } | null;
  };
};
export type useCardAdvanceContentNavigation_StartContentNodeMutation = {
  response: useCardAdvanceContentNavigation_StartContentNodeMutation$data;
  variables: useCardAdvanceContentNavigation_StartContentNodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnV2Mutations",
    "kind": "LinkedField",
    "name": "LearnV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "StartContentNodePayload",
        "kind": "LinkedField",
        "name": "startContentNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentSubmission",
            "kind": "LinkedField",
            "name": "contentSubmission",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCardAdvanceContentNavigation_StartContentNodeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCardAdvanceContentNavigation_StartContentNodeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "70ca02d65a68741c44c34162353af08a",
    "id": null,
    "metadata": {},
    "name": "useCardAdvanceContentNavigation_StartContentNodeMutation",
    "operationKind": "mutation",
    "text": "mutation useCardAdvanceContentNavigation_StartContentNodeMutation(\n  $input: StartContentNodeInput!\n) {\n  LearnV2 {\n    startContentNode(input: $input) {\n      contentSubmission {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e8ef5c96bf6fb57ae4e525ba597416d1";

export default node;
